import React, { useState, useEffect } from "react";
import "./HomePage.css";

const stats = [
  { number: "24/7", label: "Security & Support" },
  { number: "2", label: "Room Options" },
  { number: "12+", label: "Essential Amenities" },
  { number: "3x", label: "Meals a Day" },
];

const highlights = [
  {
    title: "WiFi",
    desc: "High-speed internet for work, study, and entertainment.",
    image: "/images/wifi.jpeg",
  },
  {
    title: "Three Times Food",
    desc: "Nutritious meals served three times a day.",
    image: "/images/food.jpeg",
  },
  {
    title: "Fully Furnished",
    desc: "Bed, wardrobe, chair, and study table included.",
    image: "/images/room.jpeg",
  },
  {
    title: "Security",
    desc: "CCTV & biometric security system.",
    image: "/images/security.jpeg",
  },
  {
    title: "Refrigerator",
    desc: "Shared refrigerator facility.",
    image: "/images/fridge.jpeg",
  },
  {
    title: "Washing Machine",
    desc: "Laundry facility available.",
    image: "/images/washing.jpeg",
  },
  {
    title: "RO Water",
    desc: "Hot and cold water available.",
    image: "/images/water.jpeg",
  },
  {
    title: "Power Backup",
    desc: "24/7 automated backup.",
    image: "/images/power.jpeg",
  },
  {
    title: "Housekeeping",
    desc: "Regular cleaning support.",
    image: "/images/cleaning.jpeg",
  },
  {
    title: "Self Cooking",
    desc: "Cooking facility available.",
    image: "/images/cooking.jpeg",
  },
  {
    title: "Geyser",
    desc: "Hot water facility.",
    image: "/images/geyser.jpeg",
  },
  {
    title: "Parking",
    desc: "Parking space available.",
    image: "/images/parking.jpeg",
  },
];

const roomTypes = [
  {
    title: "Single Sharing",
    price: "₹18000/mo",
    desc: "A private and comfortable space designed for premium individual living.",
    image: "/images/single.jpeg",
  },
  {
    title: "Double Sharing",
    price: "₹10000/mo",
    desc: "A spacious and affordable shared room with all essential comforts.",
    image: "/images/double.jpeg",
  },
];


const HomePage = () => {

useEffect(() => {
  const elements = document.querySelectorAll(
    ".reveal-up, .reveal-right, .reveal-img, .reveal-zoom"
  );

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
        }
      });
    },
    { threshold: 0.2 }
  );

  elements.forEach((el) => observer.observe(el));

  return () => observer.disconnect();
}, []);

useEffect(() => {
  const elements = document.querySelectorAll(
    ".reveal-up, .reveal-right, .reveal-img, .reveal-zoom, .reveal-card"
  );

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
        }
      });
    },
    { threshold: 0.15 }
  );

  elements.forEach((el) => observer.observe(el));

  return () => observer.disconnect();
}, []);

useEffect(() => {
  const elements = document.querySelectorAll(
    ".reveal-up, .reveal-right, .reveal-img, .reveal-zoom, .reveal-card, .reveal-room"
  );

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
        }
      });
    },
    { threshold: 0.15 }
  );

  elements.forEach((el) => observer.observe(el));

  return () => observer.disconnect();
}, []);

 const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="homepage">
      <section
      id="home"
      className="hero"
      style={{
        backgroundImage: isMobile
          ? `url("/images/bg1.png")`   
          : `url("/images/bg.png")`,       
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundPosition: isMobile ? "center right" : "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="hero__overlay"></div>

      <div className="hero__content">
        <span className="hero__eyebrow">Welcome to</span>

        <h1 className="hero__title">
          CozyRooms
          <span className="hero__title-sub">
            Luxury Ladies PG
          </span>
        </h1>

        <p className="hero__desc">
          Premium ladies PG at Chinnapanna Halli offering comfort, safety,
          quality food, and modern amenities for a peaceful living experience.
        </p>

        <div className="hero__cta">
          <a href="#contact" className="btn-primary">
            Book Now <span>→</span>
          </a>

          <a href="#rooms" className="btn-ghost">
            View Rooms
          </a>
        </div>
      </div>
    </section>

      {/* Stats bar */}
      <section className="stats">
        <div className="stats__inner">
          {stats.map((s, i) => (
            <div key={i} className="stats__item">
              <span className="stats__number">{s.number}</span>
              <span className="stats__label">{s.label}</span>
            </div>
          ))}
        </div>
      </section>

      {/* About */}
      <section id="about" className="home-about reveal-section">
  <div className="home-about__inner">
    <div className="home-about__text reveal-up">
      <span className="section-label">About Us</span>
      <h2 className="section-title">
        Luxury Stay With <br />
        <em>Comfort & Security</em>
      </h2>

      <p>
        CozyRooms Luxury Ladies PG in Chinnapanna Halli is designed for
        women who want a safe, convenient, and comfortable place to stay.
        Whether you are a student or working professional, this space is
        built to support your daily lifestyle with ease.
      </p>

      <p>
        With quality food, furnished rooms, biometric security, power
        backup, and essential amenities, CozyRooms brings together comfort
        and peace of mind in one place.
      </p>

      <a
        href="#contact"
        className="btn-outline"
        style={{ marginTop: "1.5rem", display: "inline-flex" }}
      >
        Contact Us <span>→</span>
      </a>
    </div>

    <div className="home-about__visual reveal-right">
      <div className="home-about__img-grid">
        <div className="home-about__img home-about__img--tall reveal-img reveal-delay-1">
          <img src="/images/img1.jpeg" alt="PG room" />
        </div>

        <div className="home-about__img home-about__img--short reveal-img reveal-delay-2">
          <img src="/images/img2.jpeg" alt="Dining area" />
        </div>

        <div className="home-about__img home-about__img--wide reveal-img reveal-delay-3">
          <img src="/images/img3.jpeg" alt="Common area" />
        </div>
      </div>

      <div className="home-about__badge reveal-zoom">
        <span className="home-about__badge-num">24/7</span>
        <span className="home-about__badge-text">
          Safety & <br />
          Support
        </span>
      </div>
    </div>
  </div>
</section>

      {/* Amenities */}
      <section id="amenities" className="highlights">
  <div className="highlights__inner">
    <div className="highlights__header reveal-up">
      <span className="section-label">Amenities</span>
      <h2 className="section-title">
        Everything You <em>Need</em>
      </h2>
    </div>

    <div className="highlights__grid">
      {highlights.map((h, i) => (
        <div
          key={i}
          className={`highlight-card reveal-card delay-${(i % 4) + 1}`}
          style={{
            backgroundImage: `url(${h.image})`,
          }}
        >
          <div className="highlight-card__overlay"></div>
          <h3 className="highlight-card__title">{h.title}</h3>
          <p className="highlight-card__desc">{h.desc}</p>
        </div>
      ))}
    </div>
  </div>
</section>

      {/* Gallery */}
      <section id="gallery" className="gallery">
  <div className="gallery__inner">
    <div className="gallery__header">
      <span className="section-label">Gallery</span>
      <h2 className="section-title">
        Explore Our <em>Space</em>
      </h2>
      <p>
        Take a glimpse into the elegant, secure, and well-equipped living
        environment at CozyRooms Luxury Ladies PG.
      </p>
    </div>

    <div className="gallery__slider">
      <div className="gallery__track">
        {[
          "/images/pic1.jpg",
          "/images/pic2.jpg",
          "/images/pic3.JPG",
          "/images/pic4.JPG",
          "/images/pic5.JPG",
          "/images/pic6.JPG",
          "/images/pic7.JPG",
          "/images/pic8.JPG",
          "/images/pic9.JPG",
          "/images/pic10.jpg",
          "/images/pic11.jpg",
          "/images/pic12.jpg",
          "/images/pic13.jpg",
          "/images/pic14.jpg",
          "/images/pic15.jpg",
          "/images/pic16.JPG",
          "/images/pic17.JPG",
          "/images/pic18.JPG",
          "/images/pic19.jpg",
          "/images/pic20.jpg",
          "/images/pic21.jpg",
          "/images/pic22.jpg",
          "/images/pic23.jpg",
          "/images/pic24.jpg",
          "/images/pic25.jpg",

          /* duplicate for smooth infinite scrolling */
          "/images/pic1.jpg",
          "/images/pic2.jpg",
          "/images/pic3.jpg",
          "/images/pic4.jpg",
          "/images/pic5.jpg",
          "/images/pic6.jpg",
          "/images/pic7.jpg",
          "/images/pic8.jpg",
          "/images/pic9.jpg",
          "/images/pic10.jpg",
          "/images/pic11.jpg",
          "/images/pic12.jpg",
          "/images/pic13.jpg",
          "/images/pic14.jpg",
          "/images/pic15.jpg",
          "/images/pic16.jpg",
          "/images/pic17.jpg",
          "/images/pic18.jpg",
          "/images/pic19.jpg",
          "/images/pic20.jpg",
          "/images/pic21.jpg",
          "/images/pic22.jpg",
          "/images/pic23.jpg",
          "/images/pic24.jpg",
          "/images/pic25.jpg",
        ].map((img, index) => (
          <div key={index} className="gallery__card">
            <img src={img} alt={`Gallery ${index + 1}`} className="gallery__img" />
          </div>
        ))}
      </div>
    </div>
  </div>
</section>

      {/* Rooms */}
      <section id="rooms" className="home-rooms">
  <div className="home-rooms__inner">
    <div className="home-rooms__header reveal-up">
      <span className="section-label">Accommodation</span>
      <h2 className="section-title">
        Choose Your <em>Room</em>
      </h2>
      <p>
        Select the room option that best suits your lifestyle and budget.
      </p>
    </div>

    <div className="home-rooms__grid">
      {roomTypes.map((room, i) => (
        <div
          key={i}
          className={`room-card reveal-room delay-${i + 1}`}
        >
          <div className="room-card__img">
            <img
              src={room.image}
              alt={room.title}
              className="room-card__image"
            />
            <div className="room-card__badge">{room.price}</div>
          </div>

          <div className="room-card__body">
            <h3>{room.title}</h3>
            <p>{room.desc}</p>
            <a href="#contact" className="room-card__link">
              Enquire Now →
            </a>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>

      {/* Contact / CTA */}
      <section id="contact" className="cta-banner">
        <div className="cta-banner__inner">
          <span className="section-label" style={{ color: "goldenrod" }}>
            Limited Slots Available
          </span>
          <h2 className="cta-banner__title">
            Book Your Stay <em>Today</em>
          </h2>
          <p>
            Visit CozyRooms Luxury Ladies PG at Chinnapanna Halli or call us
            now for bookings and enquiries.
          </p>

          <div style={{ marginTop: "1rem" }}>
            <p style={{ marginBottom: "0.5rem" }}>
              <strong>Phone:</strong> 7799871801
            </p>
            <p style={{ maxWidth: "700px", margin: "0 auto" }}>
              <strong>Address:</strong> Plot 48, 4th Cross Rd, opposite Bagmane
              Solarium City Campus, Friends Layout, Chinnapanna Halli,
              Bengaluru, Karnataka 560037
            </p>
          </div>

          <div className="cta-banner__buttons">
  <a
    href="tel:7799871801"
    className="btn-primary"
  >
    Call Now <span>→</span>
  </a>

  <a
    href="https://wa.me/917799871801"
    target="_blank"
    rel="noopener noreferrer"
    className="btn-whatsapp"
  >
    WhatsApp <span>→</span>
  </a>
</div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;